export const getBadgeProps = (data) => ({
    title: data?.title,
    subtitle: data?.subtitle,
    badge: {
      number: data?.badge?.number,
      bold: data?.badge?.bold,
      colorFill: data?.badge?.colorFill,
      customTextColorFill: data?.badge?.customTextColorFill,
    },
    disabled:data?.disabled,
    required:data?.required
  });
  export const generatePerkImage = (image, viewport = 'desktop', aspectratio = '') => {
    console.log('aspectratio', image, aspectratio);
    const ratio = aspectratio || viewport === 'desktop' ? '1x1' : '3x4';
    return `${image?.baseUrl + image?.perkName}-${ratio}-small${generateQueryString(image?.queryParams || {})}`;
  };
  export const generateQueryString = (params, append) => {
    let query = '';
    if (Object.keys(params).length > 0) {
      query =
        (append ? '&' : '?') +
        Object.keys(params)
          .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
          .join('&');
    }
    return query;
  };